import React, { useRef, useState, useEffect, useCallback } from "react";
import BottomSheet from "../../components/BottomSheet";
import { useNavigate, useLocation } from "react-router-dom";
import GoogleLogin from "react-google-login";
import useGoogleLogin from "../../hooks/useGoogleLogin";
import { env } from "../../env";
import { getLocalStorage } from "../../utils/function/localStorage";
import authSplashScreen1 from "../../assets/images/SplashScreen1.png";
import authSplashScreen2 from "../../assets/images/SplashScreen2.png";
import authSplashScreen3 from "../../assets/images/SplashScreen3.png";
import { toast } from 'react-hot-toast';
import { useLoginMutation } from "../../services/userApi";
import { Notification } from "../../components/ToastNotification";
import { Mail } from "lucide-react";
import { FcGoogle } from "react-icons/fc";
import { ShieldCheck } from "lucide-react";
const SplashScreen = () => {
  const navigate = useNavigate();

  // const [isChecked, setIsChecked] = useState(true);

  const token = getLocalStorage("tp_Aa_uth_access");
  const [currentSlide, setCurrentSlide] = useState(0);
  const carouselRef = useRef(null);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const [login, { data: loginData, isLoading, error }] = useLoginMutation();

  const sponsorID =
    searchParams.get("sponsorId") || searchParams.get("sponsorid");


  const handleGoogleClick = (renderProps) => {
    // if (!isChecked) {
    //   toast.error("Please check the consent box to proceed");
    //   return;
    // }
    renderProps.onClick();
  };


  // Slide content
  const slides = [
    {
      image: authSplashScreen1,
      title: "A Platform For Online Earners",
      subtitle:
        "Task Planet Is An Online Money Earning Website For The Individuals Looking For Small Tasks And Getting Paid For It",
    },
    {
      image: authSplashScreen2,
      title: "Best And Trusted Platform",
      subtitle:
        "Task Planet Is An Online Money Earning Website For The Individuals Looking For Small Tasks And Getting Paid For It",
    },
    {
      image: authSplashScreen3,
      title: "Earn Commisions From Team",
      subtitle: "Earn Every Time Your Team Completes any Task",
    },
  ];

  // Handle manual scroll detection
  const onScroll = useCallback(
    (e) => {
      if (!carouselRef.current) return;

      const scrollLeft = e.target.scrollLeft;
      const slideWidth = carouselRef.current.clientWidth;
      const newIndex = Math.round(scrollLeft / slideWidth);

      if (newIndex !== currentSlide) {
        setCurrentSlide(newIndex);
      }
    },
    [currentSlide]
  );

  // Auto slide functionality
  useEffect(() => {
    const interval = setInterval(() => {
      const nextIndex = (currentSlide + 1) % slides.length;
      setCurrentSlide(nextIndex);

      if (carouselRef.current) {
        const scrollAmount = carouselRef.current.clientWidth * nextIndex;
        carouselRef.current.scrollTo({
          left: scrollAmount,
          behavior: "smooth",
        });
      }
    }, 5000);

    return () => clearInterval(interval);
  }, [currentSlide, slides.length]);

  useEffect(() => {
    if (loginData?.message) {
      Notification(loginData?.message, "success");
      localStorage.setItem("tp_Aa_uth_access", loginData?.data.token);
      const userCountry = loginData?.data?.country || "India";
      localStorage.setItem("userCountry", userCountry);
      navigate("/home");
      window.location.reload();


      navigate(0);
    }
    if (error) {
      Notification(error?.data?.message, "error");
    }
  }, [loginData, error, navigate]);

  // Google sign in
  const { responseGoogle, resFailed } = useGoogleLogin();

  const handleGuestLogin = async () => {
    const newObj = {
      username: "__rtesGU32vc__kkss693x",
      password: "__hdfsjd645dnnd__kk434keokldi",
      guestKey: "kj9f__94ijfd899__4k9df9j4"
    };

    await login(newObj);
  }

  return (
    <div className="tpu__splashScreen__wrapper layoutContainer">

      {/* Slider with scroll-based swiping */}
      <div className="tpu__splashScreen__slider">
        <div
          className="tpu__splashScreen__carousel"
          ref={carouselRef}
          onScroll={onScroll}
        >
          {slides.map((slide, index) => (
            <div className="tpu__splashScreen__slide" key={index}>
              <div className="tpu__splashScreen__content">
                <div className="tpu__splashScreen__img">
                  <img
                    className="tpu__splashScreen__img__img"
                    src={slide.image}
                    alt={`splash screen ${index + 1}`}
                  />
                </div>
                <div className="tpu__splashScreen__title">
                  <h2>{slide.title}</h2>
                </div>
                <div className="tpu__splashScreen__para">
                  <p>{slide.subtitle}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Dot indicators */}
        <div  className="tpu__splashScreen__dots">
          {slides.map((_, index) => (
            <span
              key={index}
              className={`dot ${currentSlide === index ? "active" : ""}`}
              onClick={() => {
                setCurrentSlide(index);
                carouselRef.current?.scrollTo({
                  left: carouselRef.current.clientWidth * index,
                  behavior: "smooth",
                });
              }}
            />
          ))}
        </div>
      </div>

      {/* Bottom Sheet */}
      <BottomSheet height="50%">
        <div
          className="tpu__splashScreen__bottomSheet__content"
          style={{
            overflow: "hidden",
            height: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div className="section__title">
            <h2>Login with Task Planet</h2>
          </div>

          <div className="section__para">
            <p>
              Login to earn points using various amazing and easy tools
              provided in the app and then use earned points for reward!!
            </p>
          </div>

          <div
            className="google__login__btn"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "10px",
              overflow: "hidden",
            }}
          >
            {token ? (
              <button
                type="button"
                className="other__login"
                onClick={() => navigate("/home")}
              >
                Go To Dashboard
              </button>
            ) : (
              <>
                <GoogleLogin
                  clientId={env.google_client_id}
                  buttonText="Sign in with google"
                  onSuccess={responseGoogle}
                  onFailure={resFailed}
                  cookiePolicy="single_host_origin"
                  render={(renderProps) => (
                    <button
                      type="button"
                      onClick={renderProps.onClick}
                      disabled={renderProps.disabled || isLoading}
                      style={{
                        width: "90%",
                        height: "45px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "10px",
                        backgroundColor: "#FFFFFF",
                        color: "#000000",
                        border: "1px solid #D1D5DB",
                        borderRadius: "24px",
                        fontSize: "15px",
                        fontWeight: "600",
                        cursor: "pointer",
                        paddingTop: 7,
                        paddingBottom: 7
                      }}
                    >
                      <FcGoogle size={22} />
                      <span>Continue with Google</span>
                    </button>
                  )}
                />

                <span
                  style={{
                    color: "#39FF14",
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                   fontSize:12,fontWeight:600 ,
                    margin: 0,
                  }}
                >
                  <ShieldCheck size={12} />
                  Recommended. Fast. Secure
                </span>

                <div
                  style={{
                    width: "90%",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    color: "#575757",
                    fontSize: "12px",
                  }}
                >
                  <span
                    style={{
                      flex: 1,
                      height: "1px",
                      backgroundColor: "#D1D5DB",
                    }}
                  />

                  <span style={{ whiteSpace: "nowrap",fontSize:10,fontWeight:600 }}>
                    Existing Users Only
                  </span>

                  <span
                    style={{
                      flex: 1,
                      height: "1px",
                      backgroundColor: "#D1D5DB",
                    }}
                  />
                </div>

                <button
                  type="button"
                  // className="google__btn"
                  disabled={isLoading}
                  onClick={() => {
                    // const path = sponsorID
                    //   ? `/authSplashScreen?sponsorId=${sponsorID}`
                    //   : "/authSplashScreen";

                    // navigate(path);
                          const path = sponsorID
                  ? `/loginWithEmail?sponsorId=${sponsorID}`
                  : "/loginWithEmail";
                navigate(path);
                  }}
                  style={{
                    width: "90%",
                    height: "45px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#FFFFFF",
                    color: "#575757",
                    border: "1px solid #D1D5DB",
                    borderRadius: "8px",
                    fontSize: "14px",
                    fontWeight: "500",
                    cursor: "pointer",
                    paddingBottom: 8,
                    paddingTop: 8
                  }}
                >
                  <Mail size={18} strokeWidth={2} style={{ marginRight: 5 }} />
                  Sign in with Email
                </button>

                <div style={{ marginTop: "14px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                  <p style={{ fontSize: "11px", color: "#6b7280", textAlign: "center", margin: "0 0 5px 0" }}>
                    By continuing, you agree to TaskPlanet's
                  </p>
                  <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", flexWrap: "wrap", gap: "6px" }}>
                    <span
                      onClick={() => navigate("/terms-and-conditions")}
                      style={{ color: "#3797F0", fontSize: "11px", fontWeight: "600", textDecoration: "underline", cursor: "pointer" }}
                    >
                      Terms & Conditions
                    </span>
                    <span style={{ color: "#6b7280", fontSize: "11px" }}>•</span>
                    <span
                      onClick={() => navigate("/privacy-policy")}
                      style={{ color: "#3797F0", fontSize: "11px", fontWeight: "600", textDecoration: "underline", cursor: "pointer" }}
                    >
                      Privacy Policy
                    </span>
                    <span style={{ color: "#6b7280", fontSize: "11px" }}>•</span>
                    <span
                      onClick={() => navigate("/contact-us")}
                      style={{ color: "#3797F0", fontSize: "11px", fontWeight: "600", textDecoration: "underline", cursor: "pointer" }}
                    >
                      Contact Us
                    </span>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </BottomSheet>
    </div>
  );
};

export default SplashScreen;
